module.exports = __webpack_public_path__ + "img/press-banner.66392831.jpg";